import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import InternationalSummaryCard from '@plebiscito/plebiscito/Card'
import TitleHeaderBase from '@plebiscito/plebiscito/TitleHeader'
import styled from 'styled-components'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { useEnvironment } from '@/app/providers/EnvironmentProvider'
import { highlightsMock } from '@/config/mocks'

export default function Highlighted({ isSkeleton: isSkeleton_ }) {
  const { highlights: highlights_ = [] } = useEnvironment()
  const areHighlights = highlights_ && highlights_.length > 0
  const isSkeleton = !areHighlights || isSkeleton_
  const highlights = areHighlights ? highlights_ : highlightsMock
  const firstN = highlights.slice(0, 5)
  return (
    <Wrapper>
      <TitleHeader isSkeleton={isSkeleton}>Destacados</TitleHeader>
      <Swiper
        modules={[Pagination, Navigation]}
        navigation={true}
        pagination={{
          clickable: true,
        }}
        slidesPerView={1}
        spaceBetween={10}
        width={340}
      >
        {firstN.map((result, index) => {
          return (
            <SwiperSlide key={index}>
              <InternationalSummaryCard
                isSkeleton={isSkeleton}
                {...result}
              />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  .swiper {
    width: 100%;
    padding: 24px 0 36px 0;
  }

  .swiper-slide {
    min-width: 340px;
  }
`

const TitleHeader = styled(TitleHeaderBase)``
